<template>
  <div class="fullheight">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" style="padding-top: 10px">
            <img
              src="../../src/assets/img/cardiff-white-text-only.png"
              id="logo"
              height="28"
              alt="cardiff logo"
            />
          </a>
        </div>
      </div>
    </nav>
    <div class="container is-fluid fullheight" id="appcontainer">
      <div class="columns fullheight is-centered">
        <div class="column" id="app-column">
          <transition name="slide" mode="out-in">
            <VerifyLoading
              v-if="page == 0"
              key="p0"
              @next="incrementPage"
              @doublenext="page += 2"
              :link="$route.params.code"
            />
            <BankVerify
              v-if="page == 1"
              key="p1"
              @next="incrementPage"
              message="To speed up the funding process, we use bank verification to automatically process your loan. You'll be asked to select your bank and enter your online banking credentials through our secure portal.<br><br>Please use your <strong>business bank account</strong>, personal accounts are not accepted."
            />
            <Finicity
              v-if="page == 2"
              key="p2"
              @next="incrementPage"
              api="bank-verification"
            />
            <UploadDoc
              v-if="page == 3"
              key="p3"
              @next="incrementPage"
              doc="Photo ID"
              api="bank-verification"
              :link="$route.params.code"
            />
            <UploadDoc
              v-if="page == 4"
              key="p4"
              @next="incrementPage"
              doc="Voided Check"
              api="bank-verification"
              :link="$route.params.code"
            />
            <VerifyFinish
              v-if="page == 5"
              key="p5"
              @next="incrementPage"
              :result="finresult"
            />
          </transition>
        </div>
      </div>
    </div>
    <footer class="footer" style="margin-top: 60px" v-if="page != 7">
      <div class="content has-text-centered">
        <img
          src="../../src/assets/img/bbb.svg"
          style="margin-left: 15px; max-width: 120px"
          alt="bbb logo"
        />
        <img
          src="../../src/assets/img/ssl.svg"
          style="margin-left: 15px; max-width: 120px; margin-right: 15px"
          alt="SSL logo"
        />
        <p style="font-size: 0.675em; margin-top: 10px">
          © 2025 Cardiff, Inc
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  VerifyLoading,
  BankVerify,
  Finicity,
  FinicityResult,
  VerifyFinish,
  UploadDoc,
} from "@/components/apply/pages";
import { build } from "@/tools/modelBuilder";
export default {
  name: "VerifyBank",
  components: {
    BankVerify,
    Finicity,
    VerifyFinish,
    VerifyLoading,
    UploadDoc,
  },
  data() {
    return {
      page: 0,
      demo: false,
      customerId: null,
      model: { name: "" },
      finresult: false,
    };
  },
  methods: {
    incrementPage: function (pageData) {
      console.log(pageData);
      this.validate();
      build(this.model, pageData);
      if (pageData.customerId) {
        console.log("we have the customer id ", pageData.customerId);
        this.customerId = pageData.customerId;
      }
      if (pageData.finresult) {
        console.log("finresult", pageData.finresult);
        this.finresult = pageData.finresult;
      }
      this.page++;
      window.scrollTo(0, 0);
    },
    validate: function () {
      console.log(this.$route.params.code);
    },
  },
  mounted: function () {
    if (!this.demo) {
      return;
    }
    const self = this;
    setInterval(function () {
      if (self.page === 1) {
        self.page += 2;
      } else if (self.page === 6 || self.page === 3) {
        self.page += 3;
      } else if (self.page < 9) {
        self.page++;
      }
    }, 3000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
@media screen and (min-width: 767px), print {
  .mobile-only {
    display: none;
  }
  .fullheight {
    height: 100%;
  }
  #app-column {
    padding: 50px 120px;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column {
    display: none;
  }
  #app-column {
    min-height: 100vh;
    padding-top: 50px;
  }
}

#cardiff-column {
  background: #f1f1f1;
  z-index: 1;
  padding-top: 100px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}
</style>
